import { React } from "react";
import { Navigate } from "react-router-dom";
import { useAppContext } from "../AppContext";
import { readFromToken } from "../auth.ts";

const Signout = () => {
  const { removeToken } = useAppContext();

  if (readFromToken()) {
    removeToken();
  }

  return <Navigate to='/' />;
};

export default Signout;
